import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import type { ClientMessengers } from '@nebalkon-workspace/cabinet-core';
import { buildClientMessengerActions } from '@nebalkon-workspace/cabinet-core';

@Component({
  selector: 'lib-staff-client-messenger-actions',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe],
  templateUrl: './staff-client-messenger-actions.component.html',
  styleUrl: './staff-client-messenger-actions.component.scss',
})
export class StaffClientMessengerActionsComponent {
  readonly messengers = input<ClientMessengers | null>(null);
  readonly showPhone = input(false);
  readonly phone = input<string | null>(null);
  readonly compact = input(false);

  protected readonly actions = computed(() =>
    buildClientMessengerActions(this.messengers()),
  );

  protected readonly showTel = computed(
    () => this.showPhone() && !!this.phone()?.trim(),
  );

  protected readonly hasActions = computed(
    () => this.showTel() || this.actions().length > 0,
  );
}
